import '../../public/attendance-video-queue.js'
import { ref } from 'vue'
import { apiClient } from './apiClient'
const queue = globalThis.AttendanceVideoQueue
export const pendingVideoCount = ref(0)
export const videoQueueMessage = ref('')
let activeUid = null
const running = new Map()
export function setVideoQueueUser(uid) {
  activeUid = uid || null
  pendingVideoCount.value = 0
  videoQueueMessage.value = ''
}
async function credentials() {
  const result = await apiClient.get('/v1/attendance-actions/state', {
    adapter: async config => ({ data: { baseUrl: config.baseURL.replace(/\/$/, ''), authorization: config.headers.get('Authorization') }, status: 200, statusText: 'OK', headers: {}, config }),
  })
  return result.data
}
export async function stageAttendanceVideo(uid, punch, blob) {
  if (!blob?.size) throw new Error('The recorded video is empty. Please scan again.')
  try {
    await queue.put({ id: punch.id, uid, punch, blob, createdAt: Date.now(), leaseUntil: 0 })
  } catch {
    throw new Error('Could not temporarily save the video. Free some device storage and try again.')
  }
}
export async function discardStagedVideo(id) { await queue.remove(id) }
export async function refreshVideoQueueStatus(uid = activeUid) {
  if (!uid) { pendingVideoCount.value = 0; videoQueueMessage.value = ''; return }
  try {
    const jobs = (await queue.list()).filter(job => job.uid === uid)
    if (uid !== activeUid) return
    pendingVideoCount.value = jobs.length
    videoQueueMessage.value = jobs.find(job => job.error)?.error || ''
  } catch { videoQueueMessage.value = 'Unable to access temporary video uploads on this device.' }
}
async function wakeWorker() {
  if (!('serviceWorker' in navigator)) return
  const registration = await navigator.serviceWorker.getRegistration()
  if (!registration) return
  if (registration.sync) await registration.sync.register(queue.TAG)
  registration.active?.postMessage({ type: 'attendance-videos-upload' })
}
export async function resumeAttendanceVideos(uid) {
  if (!uid || uid !== activeUid) return
  if (running.has(uid)) return running.get(uid)
  const task = (async () => {
    try {
      const jobs = (await queue.list()).filter(job => job.uid === uid)
      await refreshVideoQueueStatus(uid)
      if (!jobs.length) return
      const auth = await credentials()
      if (activeUid !== uid || !auth.authorization) return
      for (const job of jobs) await queue.change(job.id, current => ({ ...current, ...auth }))
      void wakeWorker().catch(() => {})
      // Also works when Background Sync or service workers are unavailable.
      await queue.drain(uid)
    } catch { if (activeUid === uid) videoQueueMessage.value = 'Video upload pending. Reopen when connected to retry.' }
    finally { await refreshVideoQueueStatus(activeUid) }
  })()
  running.set(uid, task)
  try { await task } finally { running.delete(uid) }
}
